import { Command, HttpMethod } from "~/extensions/api";
export class GetBukenCommand extends Command {
    constructor(buknCd) {
        super(HttpMethod.Get, `common/buken/${buknCd}`);
    }
}
